import { render, staticRenderFns } from "./index.vue?vue&type=template&id=eefc2f74&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefc2f74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eefc2f74')) {
      api.createRecord('eefc2f74', component.options)
    } else {
      api.reload('eefc2f74', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=eefc2f74&scoped=true", function () {
      api.rerender('eefc2f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/paidMembers/index.vue"
export default component.exports